import { render, staticRenderFns } from "./ModalEfetuarRetirada.vue?vue&type=template&id=f2f6ec76&"
import script from "./ModalEfetuarRetirada.vue?vue&type=script&lang=js&"
export * from "./ModalEfetuarRetirada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports